import { render, staticRenderFns } from "./ParcelCheck.vue?vue&type=template&id=4788537a&"
import script from "./ParcelCheck.vue?vue&type=script&lang=js&"
export * from "./ParcelCheck.vue?vue&type=script&lang=js&"
import style0 from "./ParcelCheck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports